import { SelectedLabels } from '@kosmos/shared';
import { IMetadatas } from "../../app/apiSlice";
import { VSLabel } from '@kosmos/shared/build/cjs/types/VSLabels';

// fonction to find if some existing label of the exist are applicable on our current platform
export const addExistingLabel = (metadatas: IMetadatas | undefined, labels: VSLabel[]) => {
  if (metadatas != undefined && metadatas != null) {
    let updatedLabels: SelectedLabels = {};
    for (const key in metadatas) {
      const value = metadatas[key];
      if (labels && Array.isArray(labels)) {
        labels.forEach((label) => {
            if(key == label.id) {
            if (typeof value === 'string') {
                const isMatch = label.options?.some(obj => obj.label === value);
                if (isMatch || label.storageType == "text") {
                updatedLabels[key] = value;
                }
            } else if (Array.isArray(value) && value.every(v => typeof v === 'string')) {
                const matches = value.filter(val => label.options?.some(obj => obj.label === val));
                if (matches.length > 0) {
                updatedLabels[key] = matches;
                }
            } else {
                // only string and stringarray, ignore others applied label types for now
            }
            }
        });
      }
    }
    return updatedLabels
  }
};